import { shoppingCartContext } from 'layout/ShoppingCartContext'
import { useContext } from 'react'

export const useShoppingCart = () => useContext(shoppingCartContext)
